module.exports = __webpack_public_path__ + "static/media/telegram.7a1f1852.svg";